import * as Builders from "./builders/index.js";
import * as DeviceAttributes from "./device/index.js";
import * as DeviceTypeAttributes from "./deviceType/index.js";
import * as FirmwareApplicationAttributes from "./firmwareApplication/index.js";
import * as FirmwareComponentAttributes from "./firmwareComponent/index.js";
import * as FirmwareReleaseAttributes from "./firmwareRelease/index.js";
import * as Renderers from "./renderers/index.js";
import { install } from "./PluginSetup.js";
export default {
  Builders,
  DeviceAttributes,
  DeviceTypeAttributes,
  FirmwareApplicationAttributes,
  FirmwareComponentAttributes,
  FirmwareReleaseAttributes,
  Renderers,
  install
};